import { useDsToastNotifierStore } from "../../components/toast/DsToastNotifierStore";

import type { DsToastNotification } from "./DsNotifier.types";

export class DsNotifier {
  static sendInfo(notification: DsToastNotification): number {
    const defaults = {
      themeColor: "blue",
      duration: 10,
      enableClose: true,
      position: "bottom-0 right-0",
      overlay: false,
    };
    return DsNotifier.store({
      ...defaults,
      ...notification,
    } as DsToastNotification);
  }

  static sendSuccess(notification: DsToastNotification): number {
    const defaults = {
      themeColor: "green",
      duration: 10,
      enableClose: true,
      position: "bottom-0 right-0",
      overlay: false,
    };
    return DsNotifier.store({
      ...defaults,
      ...notification,
    } as DsToastNotification);
  }

  static sendWarning(notification: DsToastNotification): number {
    const defaults = {
      themeColor: "yellow",
      duration: 10,
      enableClose: true,
      position: "bottom-0 right-0",
      overlay: false,
    };
    return DsNotifier.store({
      ...defaults,
      ...notification,
    } as DsToastNotification);
  }

  static sendError(notification: DsToastNotification): number {
    const defaults = {
      themeColor: "red",
      duration: 10,
      enableClose: true,
      position: "bottom-0 right-0",
      overlay: false,
    };
    return DsNotifier.store({
      ...defaults,
      ...notification,
    } as DsToastNotification);
  }

  private static store(notification: DsToastNotification): number {
    const id = Math.floor(Math.random() * 1000000);
    useDsToastNotifierStore().addNotification({
      id: id,
      ...notification,
    });
    return id;
  }

  static delete(id: number): void {
    useDsToastNotifierStore().deleteNotification(id);
  }
}
